import { Formik } from 'formik';
import React from 'react';
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { IRegenerateLetterModalForm } from '../../models/driver-debt';
import { IRegenerateLetterModalProps } from '../../types/propTypes';
import { IRegenerateLetterModalState } from '../../types/stateTypes';
import { RegenerateLetterSchema } from '../../validation/driver-debt/driver-debt-validation';
import { SelectBox } from '../../components/reactstrap-formik';
import { IDriverDebtorLetters } from '../../models/driver';
import DriverService from '../../services/driver/driver-service';
import { toast } from 'react-toastify';
import StandardResponse from '../../models/standard-response';

class RegenerateLetterModal extends Component<IRegenerateLetterModalProps, IRegenerateLetterModalState> {
    private driverService: DriverService;

    private initialValues: IRegenerateLetterModalForm = {
        debtorLetter: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            debtLetters: [],
        };
        this.driverService = new DriverService();
    }

    async componentDidMount() {
        const { runHistoryDetails, s1Letters, s2Letters } = this.props;
        let debtLetters: IDriverDebtorLetters[] | null = [];
        if (runHistoryDetails.chase_report_type && runHistoryDetails.chase_report_type.code === 'STRIKE_ONE') {
            debtLetters = s1Letters;
        } else if (runHistoryDetails.chase_report_type && runHistoryDetails.chase_report_type.code === 'STRIKE_TWO') {
            debtLetters = s2Letters;
        }
        this.setState({ debtLetters });
    }

    handleSubmit = async (values: IRegenerateLetterModalForm) => {
        const { runHistoryDetails } = this.props;
        const inputData = {
            template_id: values.debtorLetter.id,
            chase_report_data_id: runHistoryDetails.id,
        };
        await this.driverService
            .regenerateChaseReport(inputData)
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
                this.props.refreshPastLettersList();
                this.props.closeModal();
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
    };

    render() {
        const { t, showModal, closeModal, runHistoryDetails } = this.props;

        return (
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('driverDebt.label.regenerateLetters')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        enableReinitialize
                        initialValues={this.initialValues}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={RegenerateLetterSchema()}
                        onSubmit={(values: IRegenerateLetterModalForm) => this.handleSubmit(values)}
                    >
                        {(props) => {
                            const { handleSubmit, setFieldTouched, setFieldValue, touched, errors, values } = props;
                            return (
                                <form
                                    id="regenerateLetterForm"
                                    onSubmit={handleSubmit}
                                    noValidate
                                    autoComplete="off"
                                    className="mb-3"
                                >
                                    <SelectBox
                                        name="debtorLetter"
                                        label={
                                            runHistoryDetails.chase_report_type &&
                                            runHistoryDetails.chase_report_type.code === 'STRIKE_ONE'
                                                ? t('driverDebt.button.strikeOneLetter')
                                                : t('driverDebt.button.strikeTwoLetter')
                                        }
                                        value={values.debtorLetter}
                                        options={this.state.debtLetters}
                                        isMulti={false}
                                        isInvalid={true}
                                        className={
                                            Boolean(touched['debtorLetter'] && errors['debtorLetter'])
                                                ? 'form-group is-invalid'
                                                : 'form-group'
                                        }
                                        onChange={(value) => {
                                            setFieldValue('debtorLetter', value !== null ? value : null);
                                        }}
                                        onBlur={() => setFieldTouched('debtorLetter', true)}
                                        placeholder={
                                            runHistoryDetails.chase_report_type &&
                                            runHistoryDetails.chase_report_type.code === 'STRIKE_ONE'
                                                ? t('driverDebt.placeholder.strikeOneLetter')
                                                : t('driverDebt.placeholder.strikeTwoLetter')
                                        }
                                        touched={touched.debtorLetter}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        errors={errors.debtorLetter}
                                    />
                                    <div className="btn-block clearfix ModelBtn">
                                        <button
                                            type="submit"
                                            className="btn btn-primary mr-2 mb-2"
                                            title={t<string>('driverDebt.label.regenerate')}
                                        >
                                            <span>{t('driverDebt.label.regenerate')}</span>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary mb-2"
                                            title={t<string>('driverDebt.label.cancel')}
                                            onClick={closeModal}
                                        >
                                            <span>{t('driverDebt.label.cancel')}</span>
                                        </button>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>
        );
    }
}
export default RegenerateLetterModal;
